import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CustomButton from "../CustomButton";
import Scan from "../../assets/Scan.png";
import Setting from "../../assets/Setting.png";
import Approve from "../../assets/Approve.png";
import CustomInput from "../CustomInput";
import { useEffect, useState } from "react";
import { CloseOutlined } from "@mui/icons-material";
import ModalForms from "./ModalForms";
import AdditionalCost from "./AdditionalCost/AdditionalCost";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CustomSelect from "../CustomSelect";
import { useDispatch } from "react-redux";
import productApi from "../../service/productApi";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { NEWPURCHASE, SIMPLEPURCHASE } from "../../Routes/constURL";
import { parse } from "date-fns";

const PurchaseOrder = ({
  tableData,
  productOptionsList,
  mode,
  selectedSupplierId,
  additionalCostsData,
  purchaseOrderId,
  onAddNewProduct,
  selectedSupplier,
  isLoading,
  setIsLoading,
  formData,
  entities
}) => {
  const navigate = useNavigate();

  console.log("Other_costs data ->", entities.other_costs);
  const other_cost_data = Object.values(entities?.other_costs?.values || {});

  const [items, setItems] = useState([]);
  const [items1, setItems1] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [productOptions, setProductOptions] = useState([]);

  useEffect(() => {
    setProductOptions(
      productOptionsList?.map((product) => product.product_name)
    );
  }, [productOptionsList]);

  // Effect to update discount and tax for all items when the supplier changes
  useEffect(() => {
    if (selectedSupplier && items.length > 0) {
      setItems((currentItems) =>
        currentItems.map((item) => ({
          ...item,
          discount: selectedSupplier.discount || "",
          // discount: "",
          tax: selectedSupplier.tax_rule || "",
        }))
      );
    }
  }, [selectedSupplier]);

  useEffect(() => {
    if (mode === "VIEW" || mode === "EDIT") {
      setItems(tableData || []);
      setItems1(additionalCostsData || []);
    }
  }, [mode, tableData, selectedSupplierId, additionalCostsData]);

  const modalFields = [
    // ... (modal fields content)
  ];

  const addItem = () => {
    setItems([
      ...items,
      {
        id: items.length + 1,
        product: "",
        quantity: 1,
        price: "",
        tax: selectedSupplier?.tax_rule || "",
        total: "",
        internal_sku: "",
        notes: "",
        unit: "",
        // discount: selectedSupplier?.discount || "",
        discount: 0,
      },
    ]);
  };
  
  const addItem1 = () => {
    setItems1([
      ...items1,
      {
        id: items1.length + 1,
        isNew: true, // Flag to identify a new row
        description: "",
        comment: "",
        quantity: "",
        price: "",
        discount: 0,
        tax: "",
        total: 0,
      },
    ]);
  };
  const removeItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };
  const removeItem1 = (id) => {
    setItems1(items1.filter((item) => (item.id || item.href) !== (id || item.href)));
  };

  const handleItemChange = (id, field, value) => {
    setItems((currentItems) =>
      currentItems.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };
          // Recalculate total if price or discount changes
          if (field === "price" || field === "discount") {
            const price = parseFloat(updatedItem.price) || 0;
            const quantity = parseInt(updatedItem.quantity, 10) || 0;
            const discount = parseFloat(updatedItem.discount) || 0;
            const subtotal = price * quantity;
            updatedItem.total = subtotal - subtotal * (discount / 100);
          }
          return updatedItem;
        }
        return item;
      })
    );
  };

  const handleAdditionalCostChange = (id, field, value) => {
    setItems1((currentItems) =>
      currentItems.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };
          if (["quantity", "price", "discount"].includes(field)) {
            const quantity = parseFloat(updatedItem.quantity) || 0;
            const price = parseFloat(updatedItem.price) || 0;
            const discount = parseFloat(updatedItem.discount) || 0;
            const subtotal = price * quantity;
            updatedItem.total = subtotal - subtotal * (discount / 100);
          }
          return updatedItem;
        }
        return item;
      })
    );
  };

  console.log("Formdata -> ", formData);
  console.log("Products -> ", items);
  console.log("Supplier data -> ", selectedSupplier);

  useEffect(() => {
    setItems([])
    setItems1([])
  }, [selectedSupplierId])

  const handleProductChange = (id, value) => {
    const selectedProduct = productOptionsList.find(
      (p) => p.product_name === value
    );
    setItems(
      items.map((item) =>
        item.id === id
          ? {
              id: item.id, // Retain temporary row ID
              product_id: selectedProduct.id, // Store actual product ID
              product_name: selectedProduct.product_name,
              quantity: item.quantity,
              price: selectedProduct ? selectedProduct.price : "",
              // discount: selectedSupplier?.discount || "",
              discount: 0,
              tax_rule: selectedSupplier?.tax_rule || "",
              // notes: item.notes,
              total: selectedProduct ? (selectedProduct.price || 0) * (item.quantity || 1) : 0,

              internal_sku: selectedProduct ? selectedProduct.internal_sku : "",
              net_content_unit_of_measure: selectedProduct
                ? selectedProduct.net_content_unit_of_measure
                : "",
            }
          : item
      )
    );
  };

  const handleOtherCostChange = (id, value) => {
    const selectedCost = other_cost_data.find((c) => c.description === value);
    if (selectedCost) {
      setItems1(
        items1.map((item) =>
          item.id === id
            ? { 
                ...selectedCost,
                quantity: item.quantity || 1, 
                id: item.id, // Retain temporary ID
                isNew: false, // It's no longer a "new" row for dropdown purposes
                discount: 0, // Initialize discount
                total: (selectedCost.price || 0) * (item.quantity || 1), // Calculate initial total
              }
            : item
        )
      );
    }
  };

  const handleModalFormSave = (formValues) => {
    // When the modal is saved, call the onAddNewProduct prop
    // to update the parent component's state.
    onAddNewProduct(formValues);
    setOpenModal(false);
  };

  console.log("Products table data: ", items);
  console.log("Additional cost table data: ", items1);
  
  const handleSave = async () => {
    const payload = {
      order_date: formData.order_date,
      delivery_date: formData.delivery_date,
      status: formData.status,
      currency: formData.currency,
      required_by: formData.required_by,
      notes: formData.comments,
      organisations: [
        {
          href: `/organisation/${formData.supplier}`,
        },
      ],
      products: items.map((item) => {
        let productId = item.product_id;
        if (!productId && item.href) {
          productId = item.href.split("/").pop();
        }
        console.log(productId);
        return {
          href: `/product/${productId}`,
          quantity: parseInt(item.quantity),
          price: parseFloat(item.price),
          discount: parseFloat(item.discount) || 0,
          tax_rule: item.tax_rule,
          notes: item.notes,
        };
      }),
      other_costs: items1.map((item) => {
        return {
          href: item.href,
          description: item.description,
          quantity: parseInt(item.quantity),
          price: parseFloat(item.price) || 0,
          discount: parseFloat(item.discount) || 0,
          tax_rule: item.tax_rule
        }
      }),
    };

    setIsLoading(true);
    try {
      if (mode === "EDIT") {
        // In EDIT mode, we call the update API with the purchase order ID.
        const response = await productApi.updatePurchaseOrder({
          id: purchaseOrderId,
          data: payload,
        });
        console.log(response)
        if (response.data && response.status === 200) {
          navigate(SIMPLEPURCHASE, { state: { successMessage: "Purchase Order updated successfully!" } });
        }
      } else {
        // In ADD mode, we create a new purchase order.
        const response = await productApi.createPurchaseOrder(payload);
        console.log(response)
        if (response.data && response.status === 201) {
          navigate(SIMPLEPURCHASE, { state: { successMessage: "Purchase Order created successfully!" } });
        }
      }
    } catch (error) {
      console.error("Failed to create purchase order:", error);
      toast.error(error?.response?.data?.message || "Failed to save purchase order.");
    }
  };

  const handleQuantityChange = (id, value) => {
    const newQuantity = value === "" ? "" : Math.max(1, Number(value));

    setItems(
      items.map((item) =>
        item.id === id
          ? {
              ...item,
              quantity: newQuantity,
              total: item.price
                ? (item.price * newQuantity) *
                  (1 - (parseFloat(item.discount) || 0) / 100)
                : 0,
            }
          : item
      )
    );
  };

  const handleTaxChange = (id, value) => {
    setItems(
      items.map((item) => (item.id === id ? { ...item, tax: value } : item))
    );
  };

  return (
    <>
      <Box sx={{ bgcolor: "white", borderRadius: "10px" }}>
        {/* Header */}
        <Typography
          sx={{
            height: "40px",
            color: "gray",
            p: 2,
            borderBottom: "1px solid gray",
            display: "flex",
            alignItems: "center",
          }}
        >
          Order / Invoice / Stock Received / Credit Note / Remove stock{" "}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pb: 2,
            borderBottom: "1px solid black",
            p: 2,
          }}
        >
          <Typography variant="h6">PRODUCTS TABLE</Typography>
          <CustomButton
            text={"Approve"}
            bgcolor={"#95ABEB"}
            color={"black"}
            img={Approve}
          />
        </Box>
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: { xs: "100%", md: "45%", xl: "14%" },
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={addItem}
              disabled={mode === "VIEW" || !selectedSupplierId} // This logic now works correctly
              sx={(theme) => ({
                p: 0,
                border: `1px solid ${!selectedSupplierId ? "grey" : "#95ABEB"}`,
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
              })}
            >
              <AddIcon
                sx={{ color: !selectedSupplierId ? "grey" : "#95ABEB" }} // This logic now works correctly
              />
            </IconButton>

            <Button
              sx={{
                border: "1px solid black",
                width: "90px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                p: 0,
                minWidth: "90px",
              }}
            >
              <img src={Scan} alt="scan" />
              <Typography sx={{ textTransform: "none", color: "black" }}>
                Scan
              </Typography>
            </Button>

            <Button
              sx={{
                border: "1px solid black",
                height: "40px",
                px: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "90px",
              }}
            >
              <Typography sx={{ textTransform: "none", color: "black" }}>
                Validate Order
              </Typography>
            </Button>
          </Box>

          <TableContainer
            className="table"
            sx={{
              borderRadius: 2,
              border: "1px solid",
              overflow: "scroll",
              mb: 3,
              mt: 2,
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                    <img
                      src={Setting}
                      style={{ filter: "invert()", width: "30px" }}
                      alt="setting"
                    />
                  </TableCell> */}
                  <TableCell style={{ width: "17%" }}>Product</TableCell>
                  <TableCell>Note</TableCell>
                  <TableCell>Supplier SKU</TableCell>
                  <TableCell>Unit</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Discount</TableCell>
                  <TableCell>Tax</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items?.map((item) => (
                  <TableRow key={item.id}>
                    {/* <TableCell>
                      <IconButton>
                        <EditIcon />
                      </IconButton>
                    </TableCell> */}

                    <TableCell>
                      {mode === "VIEW" ||
                      (mode !== "VIEW" && item.product_name) ? (
                        <TextField
                          id={item.product_id}
                          value={item.product_name}
                          variant="standard"
                          disabled
                        />
                      ) : (
                        <CustomSelect
                          name="product"
                          value={
                            item.product?.product_name ||
                            item.product_name ||
                            ""
                          }
                          data={productOptions}
                          handleChange={(e) =>
                            handleProductChange(item.id, e.target.value)
                          }
                          handleAddClick={() => setOpenModal(true)}
                          searchable
                          placeholder="Type to search..."
                          sx={{ fontSize: "12px" }}
                          disabled={mode === "VIEW"}
                        />
                      )}
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={item.notes}
                        onChange={(e) =>
                          handleItemChange(item.id, "notes", e.target.value)
                        }
                        variant="standard"
                        disabled={mode === "VIEW" && true}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={item.internal_sku}
                        variant="standard"
                        disabled
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={item.net_content_unit_of_measure}
                        fullWidth
                        disabled
                        variant="standard"
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={item.quantity}
                        onChange={(e) =>
                          handleQuantityChange(item.id, e.target.value)
                        }
                        variant="standard"
                        fullWidth
                        disabled={mode === "VIEW" && true}
                        sx={{ display: "flex", justifyContent: "center" }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={item.price}
                        onChange={(e) =>
                          handleItemChange(item.id, "price", e.target.value)
                        }
                        fullWidth
                        variant="standard"
                        disabled={mode === "VIEW" && true}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={item.discount}
                        onChange={(e) =>
                          handleItemChange(item.id, "discount", e.target.value)
                        }
                        variant="standard"
                        disabled={mode === "VIEW"}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={selectedSupplier?.tax_rule || ""}
                        onChange={(e) =>
                          handleTaxChange(item.id, e.target.value)
                        }
                        variant="standard"
                        disabled
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={item.total}
                        fullWidth
                        variant="standard"
                        disabled={true}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => removeItem(item.id || item.href)}
                        sx={{ display: `${mode === "VIEW" && "none"}` }}
                        disabled={mode === "VIEW" && true}
                      >
                        <CloseOutlined />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Box sx={{ display: `flex`, gap: 2, mb: 2, p: 2 }}>
              <Button
                onClick={addItem}
                disabled={mode === "VIEW" || !selectedSupplierId} // This logic now works correctly
                startIcon={<AddIcon />}
                sx={{
                  fontSize: "12px",
                  color: !selectedSupplierId ? "grey" : "#85ABEB",
                }}
              >
                Add More Items
              </Button>

              <Button
                disabled={mode === "VIEW" ? true : false}
                sx={{
                  fontSize: "12px",
                  display: "flex",
                  gap: 1,
                  color: !selectedSupplierId ? "grey" : "#85ABEB",
                }}
              >
                <FileUploadIcon />
                <span>Export</span>
              </Button>

              <Button
                disabled={mode === "VIEW" ? true : false}
                sx={{
                  fontSize: "12px",
                  display: "flex",
                  gap: 1,
                  color: !selectedSupplierId ? "grey" : "#85ABEB",
                }}
              >
                <FileDownloadIcon />
                <span>Import</span>
              </Button>
            </Box>
          </TableContainer>

          <AdditionalCost
            items={items1}
            products={productOptionsList}
            addItem={addItem1}
            removeItem={removeItem1}
            handleProductChange={handleProductChange}
            handleQuantityChange={handleQuantityChange}
            handleTaxChange={handleTaxChange}
            productOptions={productOptions}
            handleAddClick={() => setOpenModal(true)}
            handleAdditionalCostChange={handleAdditionalCostChange}
            isSupplierSelected={!!selectedSupplierId}
            mode={mode}
            entities={entities}
            handleOtherCostChange={handleOtherCostChange}
          />

          {/* <Box
            sx={{
              display: { xs: "block", md: "flex" },
              justifyContent: "space-between",
              mt: 3,
              gap: 2,
            }}
          >
            <Box sx={{ minWidth: "50%" }}>
              <CustomInput
                label={"Purchase Order Note"}
                height={"200px"}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                disabled={mode === "VIEW" ? true : false}
              />
            </Box>
            <TableContainer
              className="table"
              sx={{
                borderRadius: 2,
                border: "1px solid #000",
                overflow: "scroll",
                mt: 2,
                minHeight: "200px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ borderBottom: "1px solid", padding: "10px" }}
                    />
                    <TableCell
                      align="left"
                      sx={{ padding: "10px", borderBottom: "1px solid" }}
                    />
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        borderBottom: "1px solid",
                        padding: "10px",
                      }}
                    >
                      Order Lines
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        borderBottom: "1px solid",
                        padding: "10px",
                      }}
                    >
                      Additional Costs
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        borderBottom: "1px solid",
                        padding: "10px",
                      }}
                    >
                      Total
                    </TableCell>
                  </TableRow>
                </TableHead>
                
                <TableBody>
                  {items1.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ height: 32, borderBottom: "none" }}
                    >
                      <TableCell
                        align="left"
                        width="150px"
                        sx={{ borderBottom: "none", padding: "7px" }}
                      />
                      <TableCell
                        align="left"
                        sx={{ borderBottom: "none", padding: "7px" }}
                      >
                        <Typography
                          variant="body2"
                          color={
                            row.secondary ? "text.secondary" : "text.primary"
                          }
                          fontWeight={row.bold ? "bold" : "normal"}
                        >
                          {row.label}
                        </Typography>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ borderBottom: "none", padding: "7px" }}
                      >
                        {row.orderLines}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ borderBottom: "none", padding: "7px" }}
                      >
                        {row.additionalCosts}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ borderBottom: "none", padding: "7px" }}
                      >
                        <Typography>{row.total}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box> */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 3,
              border: "1px solid",
              borderRadius: 2,
              p: 2,
            }}
          >
            <Typography>Balance Due (CAD): 0.00</Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <CustomButton
              text={"Save"}
              bgcolor={"#95ABEB"}
              color={"black"}
              onClick={handleSave}
              disabled={mode === "VIEW" ? true : false}
            />
          </Box>
        </Box>
      </Box>
      <ModalForms
        open={openModal}
        setOpen={setOpenModal}
        data={modalFields}
        name="Add a new Product"
        handleSave={handleModalFormSave}
      />
    </>
  );
};

export default PurchaseOrder;
